import { API_ROUTES } from '@/constants/apiRoutes';
import { AxiosInstance } from 'axios';

export interface UpdatePlanRequestPayload {
  planId: string;
  lastEntryTime: string;
  planPrice: number;
  clubId: string;
  nomination: number;
  noOfPeople?: number;
  planTitleJp: string;
}

export interface TogglePlanRequestStatusPayload {
  clubId: string;
  planRequestId: string;
  status: 'A' | 'R' | 'D';
}

const updatePlanRequestStatus =
  (client: AxiosInstance) => async (payload: { clubId: string; planRequestId: string; status: 'A' | 'R' | 'D' }) => {
    return (
      await client.post<{ message: string; data: { clubId: string; planRequestId: string; status: string } }>(
        API_ROUTES.UPDATE_PLAN_REQUEST_STATUS,
        {
          ...payload,
        },
      )
    ).data;
  };

const updatePlanRequest = (client: AxiosInstance) => async (payload: UpdatePlanRequestPayload) => {
  return (
    await client.post<{ message: string; data: UpdatePlanRequestPayload }>(API_ROUTES.UPDATE_PLAN_REQUEST, {
      ...payload,
    })
  ).data;
};

export const hoslogPlansRequestMutations = {
  updatePlanRequest,
  updatePlanRequestStatus,
};
